import { ViaModelSerieStatePopup, ModelSeriesState } from '@/types';

export const chipFilterTypes = ['allModelSeries', 'dialogInactive', 'efaInactive', 'noPlantAssigment'];

// Model series view table
export const filteringStatesModelSeriesView = [
  { columnName: 'dialog', filteringEnabled: false },
  { columnName: 'activeForEfa', filteringEnabled: false },
];

// Plants view table
export const filteringStatesPlantsView = [
  { columnName: 'dialog', filteringEnabled: false },
  { columnName: 'activeForEfa', filteringEnabled: false },
];

// Generic for admin page tables state
export const emptyStateMS: ModelSeriesState = {
  plantsActive: [],
  allModelSeriesRaw: [],
  modelSeriesView: {
    allModelSeries: [],
    dialogInactive: [],
    efaInactive: [],
    noPlantAssigment: [],
  },
  plantsView: {
    allModelSeries: [],
    dialogInactive: [],
    efaInactive: [],
    noPlantAssigment: [],
  },
};

// Popup for creation & editing
export const tableColumnExtensionsModelSeriesPopup = [
  { columnName: 'modelSeries', width: 132 },
  { columnName: 'typeVersion', width: 130 },
  { columnName: 'plants', width: 290, wordWrapEnabled: true },
];

export const tableColumnExtensionsPlantsPopup = [
  { columnName: 'modelSeries', width: 125, align: 'center' },
  { columnName: 'typeVersionRaw', width: 350 },
];
export const editingStateColumnExtensionsModelSeriesPopup = [
  { columnName: 'modelSeries', editingEnabled: false },
  { columnName: 'typeVersion', editingEnabled: false },
  { columnName: 'type', editingEnabled: false },
];

export const editingStateColumnExtensionsPlantsPopup = [
  { columnName: 'modelSeries', editingEnabled: false },
];

export const defaultMSStatePopup: ViaModelSerieStatePopup[] = [{
  modelSeries: '',
  typeVersions: [],
  msTVPlants: [],
  msType: '',
}];
